import type { MouseEvent, KeyboardEvent } from 'react';

import useOnLogout from 'hooks/useOnLogout';
import hamburger from 'images/hamburger.svg';
import downIcon from 'images/header/down.svg';
import userIcon from 'images/header/user.svg';
import logoutIcon from 'images/header/logout.svg';
import { useMainContext } from 'routes/MainContextProvider';
import { open as setOpenSignIn } from 'store/reducers/signIn';
import { Menu, Div, MenuDiv } from './elements';
import type { MenuDesktopIntegrationsProps, MenuItemValue } from './types';

const MobMenuItem = (props: MenuItemValue) => (
  <button type="button" tabIndex={0} role="menuitem" onClick={props.onClick}>
    <img src={props.icon} alt={props.name} />
    <span>{props.name}</span>
  </button>
);

const MenuDesktopIntegrations = ({
  user,
  name,
  isOpen,
  setIsOpen
}: MenuDesktopIntegrationsProps) => {
  const { local, dispatch, isLoggedIn, history } = useMainContext();
  const logout = useOnLogout();

  const onOpenSignIn = () => {
    dispatch(setOpenSignIn());
  };

  const contactUs = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    history('/integrations/start-for-free');
  };

  const signIn = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onOpenSignIn();
  };

  const toggle = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const singOut = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    logout();
    local.selectedDocuments.remove();
    local.compareDocument.delCompareDocument();
    local.auth.delUser();
    setIsOpen(false);
  };

  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
      setIsOpen(!isOpen);
    }
  };
  return (
    <Menu>
      <Div onClick={toggle} onKeyDown={onKeyDown} role='button' tabIndex={0}>
        {!isLoggedIn && (
          <>
          <button className="login" onClick={signIn}>
            <span>Login</span>
          </button>
          {!name && (
          <button className="upgrade" onClick={contactUs}>
            <span>Start for free</span>
          </button>
          )}
          </>
        )}
        {isLoggedIn && (
          <>
            <div className="name">
              <img src={userIcon} alt="user" className="user" data-tooltip-content={name} data-tooltip-id="tooltip-general" />
              <span>Hi! {user?.user?.first_name}</span>
              <img src={downIcon} alt="menu" className="down" />
            </div>
            <img src={hamburger} alt="menu" />
          </>
        )}
      </Div>
      {isOpen && (
        <MenuDiv tabIndex={-1} role="menu" aria-hidden="false">
          <MobMenuItem
            name="Logout"
            onClick={singOut}
            icon={logoutIcon} />
        </MenuDiv>
      )}
    </Menu>
  );
};

export default MenuDesktopIntegrations;
